import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { billingQKeys } from "@hooks/queries/billing/queryKeys";
import { followUpQKeys } from "@hooks/queries/followUp/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


interface MutationProps {
  billId: string;
  discount: number;
}

export const useAddDiscount = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: ({ billId, discount }: MutationProps) => {
      return api.patch(`billing/${billId}/discount`, {
        discount,
      });
    },
    onSuccess: res => {
      //   import.meta.env.DEV && console.log(res.data);
      showSuccessNotification({
        title: "success",
        message: "add-discount-success",
      });
      queryClient.invalidateQueries({
        queryKey: billingQKeys.consultation(res.data.consultation_id),
      });
      queryClient.invalidateQueries({
        queryKey: followUpQKeys.all(),
      });
    },

    onError: (res: any) => {
      console.error("[From Add Discount]", res);

      handleErrors(res, "mutation");
    },
  });
};
